

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {  OutgoingInvoiceViewModel } from '@/services/api/nswag/stapiclient_generated';
import { UserStore } from '@/store/user-module';

@Component({
  components: {},
})
export default class OutgoingInvoiceExportOther2 extends Vue {
  @Prop() model!: OutgoingInvoiceViewModel;
  @Prop() logoUrl!: string;
  @Prop() finalDescription!: string;

  get currency() {
    return UserStore.userSettings.currency;
  }
}
